import ShipmentDetail from "./components/ShipmentDetail";
import SectionHeader from "../../components/SectionHeader";

const ShipmentDetails = props => {
  const { shipment, shipmentHasConfirmedItems, formik } = props || {};

  return (
    <div className="w-full">
      <SectionHeader title={`Shipment #${shipment?.id}`} />
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-8 lg:flex-row lg:gap-0 lg:space-x-16">
          <div className="flex w-full flex-col lg:flex-row">
            <ShipmentDetail
              formik={formik}
              submitOnBlur={true}
              shipment={shipment}
              shipmentHasConfirmedItems={shipmentHasConfirmedItems}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShipmentDetails;
